export const CSS_CLASSES = {
    SHOW: "is-visible",
    OVERLAY: ".tips-overlay",
    TIP: "tip",
};
